<template>
  <nav class="unified-navbar" :class="{ 'scrolled': isScrolled }">
    <div class="navbar-container">
      <!-- Logo区域 -->
      <div class="navbar-brand">
        <router-link to="/" class="brand-link">
          <img src="/imags/logo.jpg" alt="易博数字" class="brand-logo" />
          <span class="brand-text">易博数字</span>
        </router-link>
      </div>

      <!-- 主导航菜单 -->
      <div class="nav-center">
        <div class="navbar-menu" :class="{ 'is-active': isMenuOpen }">
          <ul class="navbar-nav">
          <li class="nav-item">
            <router-link to="/" class="nav-link" @click="closeMenu">首页</router-link>
          </li>
          
          <!-- 产品下拉菜单 -->
          <li class="nav-item dropdown" @mouseenter="showDropdown('products')" @mouseleave="hideDropdown('products')">
            <a href="#" class="nav-link dropdown-toggle" @click.prevent>
              产品
            </a>
            <div class="dropdown-menu products-menu mega" :class="{ 'show': activeDropdown === 'products' }">
              <div class="products-mega">
                <!-- 左侧分类列表 -->
                <div class="mega-sidebar">
                  <div class="mega-item" :class="{ active: selectedProductCategory === 'aiot' }" @mouseenter="selectProductCategory('aiot')">
                    <div class="mega-title">AIOT平台产品</div>
                    <div class="mega-desc">智能物联网平台解决方案</div>
                  </div>
                  <div class="mega-item" :class="{ active: selectedProductCategory === 'carbon' }" @mouseenter="selectProductCategory('carbon')">
                    <div class="mega-title">能碳产品</div>
                    <div class="mega-desc">能碳管理与节能优化解决方案</div>
                  </div>
                  <div class="mega-item" :class="{ active: selectedProductCategory === 'digital' }" @mouseenter="selectProductCategory('digital')">
                    <div class="mega-title">企业数字化产品</div>
                    <div class="mega-desc">助力制造业数字化转型</div>
                  </div>
                </div>

                <!-- 右侧内容区域 -->
                <div class="mega-content">
                  <div v-show="selectedProductCategory === 'aiot'" class="mega-grid">
                    <router-link to="/aiot-platform" class="mega-card" @click="closeMenu">
                      <div class="card-title">AIOT平台</div>
                      <div class="card-desc">设备接入、数据治理、智能应用</div>
                    </router-link>
                    <router-link to="/equipment-maintenance" class="mega-card" @click="closeMenu">
                      <div class="card-title">设备运维平台</div>
                      <div class="card-desc">设备监控、故障诊断、智能维护</div>
                    </router-link>
                     <router-link to="/industrial-iot" class="mega-card" @click="closeMenu">
                      <div class="card-title">能耗在线监测系统</div>
                      <div class="card-desc">工业数据互联与统一管理</div>
                    </router-link>
                  </div>

                  <div v-show="selectedProductCategory === 'carbon'" class="mega-grid">
                    <router-link to="/factory-carbon-management" class="mega-card" @click="closeMenu">
                      <div class="card-title">碳排放管理平台</div>
                      <div class="card-desc">能耗监测与碳排核算</div>
                    </router-link>
                    <router-link to="/carbon-system-construction" class="mega-card" @click="closeMenu">
                      <div class="card-title">能碳管理平台</div>
                      <div class="card-desc">双碳策略与制度落地</div>
                    </router-link>
                    <router-link to="/carbon-asset-management" class="mega-card" @click="closeMenu">
                      <div class="card-title">碳资产管理平台</div>
                      <div class="card-desc">碳资产指标与交易管理</div>
                    </router-link>
                  </div>

                  <div v-show="selectedProductCategory === 'digital'" class="mega-grid">
                    <router-link to="/sme-digital-transformation" class="mega-card" @click="closeMenu">
                      <div class="card-title">生产一体化管理系统</div>
                      <div class="card-desc">生产、供应链与协同升级</div>
                    </router-link>
                    <router-link to="/oa-system" class="mega-card" @click="closeMenu">
                      <div class="card-title">企业OA系统</div>
                      <div class="card-desc">一体化落地方案</div>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </li>
          
          <!-- 解决方案菜单项 -->
          <li class="nav-item">
            <span class="nav-link no-click">解决方案</span>
          </li>
          
          <!-- 关于我们菜单项 -->
          <li class="nav-item">
            <span class="nav-link no-click">关于我们</span>
          </li>
          </ul>
        </div>
      </div>

      <div class="navbar-actions">
        <a href="http://console.ybszai.com" target="_blank" class="cta-button">登录IOT平台</a>
      </div>

      <!-- 移动端菜单按钮 -->
      <div class="navbar-toggle" @click="toggleMobileMenu" :class="{ 'active': isMobileMenuOpen }">
        <span class="toggle-line"></span>
        <span class="toggle-line"></span>
        <span class="toggle-line"></span>
      </div>

      <!-- Mobile Menu -->
      <div class="mobile-menu" :class="{ 'active': isMobileMenuOpen }">
        <div class="mobile-menu-item">
          <router-link to="/" @click="closeMenu">首页</router-link>
        </div>
        <div class="mobile-menu-item has-dropdown">
          <div class="mobile-menu-toggle" @click="toggleMobileDropdown('products')">
            产品
          </div>
          <div class="mobile-dropdown" :class="{ 'active': mobileDropdowns.products }">
            <div class="mobile-dropdown-section has-submenu" @mouseenter="showSubmenu('aiot')" @mouseleave="hideSubmenu('aiot')">
              <div class="mobile-submenu-toggle" @click="toggleMobileSubmenu('aiot')">
                <h4>AIOT平台产品 <i class="fas fa-chevron-right"></i></h4>
                <i class="fas fa-chevron-down" :class="{ 'rotated': mobileSubmenus.aiot }"></i>
              </div>
              <div class="mobile-submenu submenu" :class="{ 'active': mobileSubmenus.aiot || activeSubmenu === 'aiot' }">
                <router-link to="/aiot-platform" @click="closeMenu">AIOT平台</router-link>
                <router-link to="/industrial-iot" @click="closeMenu">工业互联网平台</router-link>
                <router-link to="/equipment-maintenance" @click="closeMenu">设备运维平台</router-link>
              </div>
            </div>
            <div class="mobile-dropdown-section has-submenu" @mouseenter="showSubmenu('carbon')" @mouseleave="hideSubmenu('carbon')">
              <div class="mobile-submenu-toggle" @click="toggleMobileSubmenu('carbon')">
                <h4>能碳产品 <i class="fas fa-chevron-right"></i></h4>
                <i class="fas fa-chevron-down" :class="{ 'rotated': mobileSubmenus.carbon }"></i>
              </div>
              <div class="mobile-submenu submenu" :class="{ 'active': mobileSubmenus.carbon || activeSubmenu === 'carbon' }">
                <router-link to="/factory-carbon-management" @click="closeMenu">工厂、建筑能碳管理</router-link>
                <router-link to="/carbon-system-construction" @click="closeMenu">能碳管理平台</router-link>
                <router-link to="/carbon-asset-management" @click="closeMenu">碳资产管理平台</router-link>
              </div>
            </div>
            <div class="mobile-dropdown-section has-submenu" @mouseenter="showSubmenu('digital')" @mouseleave="hideSubmenu('digital')">
              <div class="mobile-submenu-toggle" @click="toggleMobileSubmenu('digital')">
                <h4>企业数字化产品 <i class="fas fa-chevron-right"></i></h4>
                <i class="fas fa-chevron-down" :class="{ 'rotated': mobileSubmenus.digital }"></i>
              </div>
              <div class="mobile-submenu submenu" :class="{ 'active': mobileSubmenus.digital || activeSubmenu === 'digital' }">
                <router-link to="/sme-digital-transformation" @click="closeMenu">生产一体化管理系统</router-link>
                <router-link to="/oa-system" @click="closeMenu">企业OA系统</router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="mobile-menu-item">
          <span class="no-click">解决方案</span>
        </div>
        <div class="mobile-menu-item">
          <span class="no-click">关于我们</span>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'UnifiedNavBar',
  data() {
    return {
      isMenuOpen: false,
      isScrolled: false,
      activeDropdown: null,
      dropdownTimer: null,
      isMobileMenuOpen: false,
      mobileDropdowns: {
        products: false
      },
      mobileSubmenus: {
         aiot: false,
         carbon: false,
         digital: false
       },
       activeSubmenu: null,
       submenuTimer: null,
       selectedProductCategory: 'aiot'
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
    document.removeEventListener('click', this.handleClickOutside)
    if (this.dropdownTimer) {
      clearTimeout(this.dropdownTimer)
    }
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen
      if (this.isMenuOpen) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    },
    selectProductCategory(cat) {
      this.selectedProductCategory = cat
    },
    closeMenu() {
      this.isMenuOpen = false
      this.activeDropdown = null
      document.body.style.overflow = ''
    },
    handleScroll() {
      this.isScrolled = window.scrollY > 50
    },
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.closeMenu()
      }
    },
    showDropdown(dropdown) {
      if (this.dropdownTimer) {
        clearTimeout(this.dropdownTimer)
      }
      this.activeDropdown = dropdown
    },
    hideDropdown(dropdown) {
      this.dropdownTimer = setTimeout(() => {
        if (this.activeDropdown === dropdown) {
          this.activeDropdown = null
        }
      }, 300)
    },
    toggleMobileDropdown(dropdown) {
      this.mobileDropdowns[dropdown] = !this.mobileDropdowns[dropdown];
      // Close other dropdowns
      Object.keys(this.mobileDropdowns).forEach(key => {
        if (key !== dropdown) {
          this.mobileDropdowns[key] = false;
        }
      });
      // Close all submenus when closing dropdown
      if (!this.mobileDropdowns[dropdown]) {
        Object.keys(this.mobileSubmenus).forEach(key => {
          this.mobileSubmenus[key] = false;
        });
      }
    },
    toggleMobileSubmenu(submenu) {
       this.mobileSubmenus[submenu] = !this.mobileSubmenus[submenu];
       // Close other submenus
       Object.keys(this.mobileSubmenus).forEach(key => {
         if (key !== submenu) {
           this.mobileSubmenus[key] = false;
         }
       });
     },
     toggleMobileMenu() {
       this.isMobileMenuOpen = !this.isMobileMenuOpen;
       if (!this.isMobileMenuOpen) {
         this.closeMenu();
       }
     },
     closeMenu() {
        this.isMobileMenuOpen = false;
        Object.keys(this.mobileDropdowns).forEach(key => {
          this.mobileDropdowns[key] = false;
        });
        Object.keys(this.mobileSubmenus).forEach(key => {
          this.mobileSubmenus[key] = false;
        });
      },
      showSubmenu(submenu) {
        if (this.submenuTimer) {
          clearTimeout(this.submenuTimer);
        }
        this.activeSubmenu = submenu;
      },
      hideSubmenu(submenu) {
        this.submenuTimer = setTimeout(() => {
          if (this.activeSubmenu === submenu) {
            this.activeSubmenu = null;
          }
        }, 300);
      }
  }
}
</script>

<style scoped>
.unified-navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: #ffffff;
  border-bottom: 1px solid #e5e7eb;
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.unified-navbar.scrolled {
  background: #ffffff;
  border-bottom-color: #e5e7eb;
}

.navbar-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 72px;
}

.nav-center {
  position: static;
  transform: none;
  display: flex;
  justify-content: flex-start;
  flex: 1;
  padding-left: 6rem;
}

/* Logo区域 */
.navbar-brand {
  flex-shrink: 0;
  margin-right: auto;
  padding-left: 0;
  margin-left: -1rem;
}

.brand-link {
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #1f2937;
  font-weight: 600;
  font-size: 1.5rem;
  transition: all 0.3s ease;
  position: relative;
}

.brand-link:hover {
  color: #2563eb;
}

.brand-logo {
  width: 36px;
  height: 36px;
  margin-right: 12px;
  border-radius: 8px;
  object-fit: cover;
  transition: all 0.3s ease;
}

.brand-link:hover .brand-logo {
  transform: scale(1.05);
}

.brand-text {
  color: #1f2937;
  font-weight: 600;
  letter-spacing: -0.01em;
  transition: all 0.3s ease;
  font-size: 1.5rem;
}

.brand-link:hover .brand-text {
  color: #2563eb;
}

.navbar-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: auto;
  padding-right: 0;
  margin-right: -1rem;
}

.cta-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 12px 32px;
  font-size: 1.1rem;
  font-weight: 500;
  color: #2563eb;
  border: 1px solid #2563eb;
  border-radius: 6px;
  text-decoration: none;
  transition: all 0.2s ease;
  background: transparent;
}

.cta-button:hover {
  background: #2563eb;
  color: #fff;
  box-shadow: 0 4px 8px rgba(37, 99, 235, 0.2);
  transform: translateY(-1px);
}

/* 导航菜单 */
.navbar-menu {
  display: flex;
  align-items: center;
}

.navbar-nav {
  display: flex;
  align-items: center;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 0;
}

.nav-item {
  position: relative;
}

.nav-link {
  display: flex;
  align-items: center;
  padding: 1rem 3rem;
  color: #374151;
  text-decoration: none;
  font-weight: 500;
  font-size: 1.25rem;
  transition: color 0.15s ease;
  position: relative;
}

.nav-link:hover { color: #1d4ed8; }
.nav-link::after {
  content: '';
  position: absolute;
  left: 50%;
  bottom: 12px;
  width: 0;
  height: 3px;
  background: #1d4ed8;
  border-radius: 2px;
  transform: translateX(-50%);
  transition: width 0.2s ease;
}
.nav-link:hover::after { width: 32px; }
.nav-link.router-link-active { color: #1d4ed8; font-weight: 600; }
.nav-link.router-link-active::after { width: 32px; }



/* 下拉菜单 */
.dropdown-toggle {
  cursor: pointer;
}

.dropdown-icon {
  margin-left: 0.75rem;
  font-size: 0.8rem;
  opacity: 0.7;
  color: #b0b5bb;
}

.dropdown:hover .dropdown-icon {
  opacity: 1;
  color: #c0c5cb;
}

/* 禁用点击的样式 */
.no-click {
  cursor: default !important;
  pointer-events: none;
}

.dropdown-menu {
  position: fixed;
  top: 80px;
  left: 0;
  right: 0;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-radius: 0 0 12px 12px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  padding: 0;
  width: auto;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-8px);
  transition: all 0.25s ease-out;
  border: none;
  z-index: 999;
  min-height: 380px;
  overflow: hidden;
}

.dropdown-menu::before {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  pointer-events: none;
  background-image:
    radial-gradient(400px 400px at 15% 85%, rgba(37, 99, 235, 0.08) 0%, transparent 70%),
    radial-gradient(300px 300px at 85% 15%, rgba(147, 197, 253, 0.12) 0%, transparent 65%),
    linear-gradient(180deg, rgba(248, 250, 252, 0.95), rgba(241, 245, 249, 0.98));
}

.dropdown-menu.show {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.dropdown-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 2.5rem;
}

.dropdown-section {
  min-width: 0;
  position: relative;
}

.dropdown-section.has-submenu {
  cursor: pointer;
  
  h4 {
    font-size: 0.9rem;
    font-weight: 700;
    color: #2563eb;
    margin: 0 0 1rem 0;
    padding: 0.75rem 1rem;
    border-radius: 12px;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: rgba(37, 99, 235, 0.05);
    
    i {
      font-size: 0.7rem;
      transition: transform 0.3s ease;
    }
  }
  
  &:hover h4 {
    background: rgba(37, 99, 235, 0.1);
    transform: translateX(3px);
  }
  
  .submenu {
    position: absolute;
    left: 100%;
    top: 0;
    min-width: 220px;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.98) 0%, rgba(248, 250, 252, 0.98) 100%);
    backdrop-filter: blur(25px);
    border-radius: 16px;
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1), 0 5px 15px rgba(0, 0, 0, 0.05);
    padding: 1rem;
    opacity: 0;
    visibility: hidden;
    transform: translateX(-10px);
    transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    border: 1px solid rgba(226, 232, 240, 0.3);
    z-index: 1000;
    
    &.active {
      opacity: 1;
      visibility: visible;
      transform: translateX(0);
    }
    
    a {
      display: block;
      padding: 0.75rem 1rem;
      color: #475569;
      text-decoration: none;
      border-radius: 10px;
      transition: all 0.3s ease;
      font-size: 0.9rem;
      font-weight: 500;
      margin-bottom: 0.25rem;
      
      &:hover {
        color: #2563eb;
        background: rgba(37, 99, 235, 0.08);
        transform: translateX(3px);
      }
      
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}

.dropdown-header {
  font-size: 0.9rem;
  font-weight: 700;
  color: #2563eb;
  margin: 0 0 1.25rem 0;
  padding-bottom: 0.75rem;
  border-bottom: 2px solid rgba(37, 99, 235, 0.15);
}

/* 产品菜单卡片式布局样式 */
.products-menu {
  width: 100%;
  padding: 2rem 2.5rem;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
}

.products-menu.mega {
  width: 100%;
}

.products-mega {
  display: grid;
  grid-template-columns: 280px 1fr;
  gap: 56px;
  max-width: 1180px;
  margin: 0 auto;
  position: relative;
  min-height: 300px;
}

.mega-sidebar {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-radius: 16px;
  padding: 32px 24px;
  position: relative;
  border: 1px solid rgba(226, 232, 240, 0.6);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  min-width: 300px;
  margin-right: 16px;
}

.mega-sidebar::after {
  content: '';
  position: absolute;
  right: -12px;
  top: 32px;
  bottom: 32px;
  width: 1px;
  background: linear-gradient(180deg, transparent 0%, rgba(203, 213, 225, 0.4) 50%, transparent 100%);
  border-radius: 1px;
}

.mega-item {
  padding: 20px 24px;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  margin-bottom: 8px;
  background: rgba(255, 255, 255, 0.3);
  border: 1px solid rgba(226, 232, 240, 0.4);
}

.mega-item:hover { 
  background: rgba(255, 255, 255, 0.6);
  transform: translateX(4px);
  border-color: rgba(203, 213, 225, 0.6);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.mega-item.active {
  background: linear-gradient(135deg, rgba(241, 245, 249, 0.8) 0%, rgba(248, 250, 252, 0.8) 100%);
  border: 1px solid rgba(203, 213, 225, 0.8);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
  transform: translateX(2px);
}

.mega-item.active .mega-title { color: #2563eb; font-weight: 600; }
.mega-item.active .mega-desc { color: #64748b; }

.mega-item.active::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 50%;
  background: linear-gradient(180deg, #3b82f6 0%, #60a5fa 100%);
  border-radius: 0 2px 2px 0;
  opacity: 0.7;
}

.mega-title {
  font-size: 1.15rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 8px;
  line-height: 1.4;
}

.mega-desc {
  font-size: 0.95rem;
  color: #475569;
  line-height: 1.5;
  font-weight: 500;
}

.mega-content {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border: 1px solid rgba(226, 232, 240, 0.8);
  border-radius: 16px;
  padding: 24px;
  position: relative;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  margin-left: 8px;
}

.mega-grid {
  display: flex;
  gap: 24px;
  align-items: stretch;
  justify-content: flex-start;
  padding: 4px 0;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 16px;
  padding: 24px;
  border: 1px solid rgba(226, 232, 240, 0.6);
}

.mega-card {
  display: flex;
  flex-direction: column;
  text-decoration: none;
  border: 1px solid rgba(226, 232, 240, 0.8);
  border-radius: 12px;
  padding: 20px 24px;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  min-height: 120px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
  position: relative;
  overflow: hidden;
  flex: 0 0 280px;
  margin-left: 8px;
  justify-content: center;
}

.mega-card::before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 120px;
  height: 120px;
  background: radial-gradient(circle, rgba(37, 99, 235, 0.08) 0%, transparent 70%);
  border-radius: 50%;
  transform: translate(30%, -30%);
  transition: all 0.3s ease;
}

.mega-card:hover {
  border-color: rgba(37, 99, 235, 0.3);
  background: linear-gradient(135deg, #ffffff 0%, #f0f9ff 100%);
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  transform: translateY(-4px);
}

.mega-card:hover::before {
  transform: translate(20%, -20%) scale(1.2);
  background: radial-gradient(circle, rgba(37, 99, 235, 0.12) 0%, transparent 70%);
}

.mega-card .card-title {
  font-size: 1.15rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 8px;
  line-height: 1.4;
  position: relative;
  z-index: 1;
}

.mega-card .card-desc {
  font-size: 0.95rem;
  color: #64748b;
  line-height: 1.5;
  position: relative;
  z-index: 1;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.products-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
}

.product-category {
  background: rgba(255, 255, 255, 0.8);
  border-radius: 12px;
  padding: 1.25rem;
  border: 1px solid rgba(229, 231, 235, 0.6);
  transition: all 0.3s ease;
  position: relative;
}

.product-category:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
  border-color: rgba(37, 99, 235, 0.2);
}

.category-header {
  text-align: center;
  margin-bottom: 1.25rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid rgba(229, 231, 235, 0.5);
}

.category-icon {
  font-size: 2rem;
  margin-bottom: 0.5rem;
  display: block;
  transition: all 0.3s ease;
}

.product-category:hover .category-icon {
  transform: scale(1.05);
}

.category-header h3 {
  font-size: 1rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 0.25rem 0;
  line-height: 1.3;
}

.category-header p {
  font-size: 0.8rem;
  color: #6b7280;
  margin: 0;
  line-height: 1.4;
}

.product-items {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.product-item {
  display: flex;
  align-items: center;
  padding: 0.75rem;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 8px;
  text-decoration: none;
  transition: all 0.3s ease;
  border: 1px solid rgba(229, 231, 235, 0.4);
  position: relative;
}

.product-item:hover {
  background: rgba(255, 255, 255, 0.9);
  border-color: rgba(37, 99, 235, 0.3);
  transform: translateX(2px);
}

.product-icon {
  font-size: 1.25rem;
  margin-right: 0.75rem;
  flex-shrink: 0;
  transition: all 0.3s ease;
}

.product-item:hover .product-icon {
  transform: scale(1.05);
}

.product-info {
  flex: 1;
  min-width: 0;
}

.product-title {
  display: block;
  font-size: 0.875rem;
  font-weight: 500;
  color: #1f2937;
  margin-bottom: 0.125rem;
  line-height: 1.3;
  transition: all 0.3s ease;
}

.product-item:hover .product-title {
  color: #2563eb;
  font-weight: 600;
}

.product-desc {
  display: block;
  font-size: 0.75rem;
  color: #6b7280;
  line-height: 1.4;
  transition: all 0.3s ease;
}

.product-item:hover .product-desc {
  color: #4b5563;
}

.dropdown-header::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 30px;
  height: 2px;
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  border-radius: 1px;
}

.dropdown-item {
  display: flex;
  align-items: center;
  padding: 1rem;
  color: #475569;
  text-decoration: none;
  border-radius: 16px;
  transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  margin-bottom: 0.5rem;
  position: relative;
  overflow: hidden;
}

.dropdown-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(37, 99, 235, 0.06) 0%, rgba(29, 78, 216, 0.06) 100%);
  opacity: 0;
  transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  z-index: -1;
}

.dropdown-item:hover {
  color: #2563eb;
  transform: translateX(6px) translateY(-1px);
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.1);
}

.dropdown-item:hover::before {
  opacity: 1;
}

.item-icon {
  font-size: 1.4rem;
  margin-right: 1rem;
  flex-shrink: 0;
  transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  opacity: 0.8;
}

.dropdown-item:hover .item-icon {
  transform: scale(1.1);
  opacity: 1;
}

.item-content {
  flex: 1;
}

.item-title {
  display: block;
  font-weight: 700;
  font-size: 0.95rem;
  margin-bottom: 0.3rem;
  letter-spacing: -0.01em;
  transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.item-desc {
  display: block;
  font-size: 0.82rem;
  color: #64748b;
  line-height: 1.4;
  transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.dropdown-item:hover .item-desc {
  color: #475569;
}

/* 分割线样式 */
.dropdown-divider {
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(229, 231, 235, 0.8), transparent);
  margin: 0.75rem 0;
  border: none;
}

/* 查看全部样式 */
.dropdown-item.view-all {
  background: linear-gradient(135deg, rgba(37, 99, 235, 0.05), rgba(59, 130, 246, 0.08));
  border: 1px solid rgba(37, 99, 235, 0.1);
  border-radius: 8px;
  margin-top: 0.5rem;
}

.dropdown-item.view-all:hover {
  background: linear-gradient(135deg, rgba(37, 99, 235, 0.1), rgba(59, 130, 246, 0.15));
  border-color: rgba(37, 99, 235, 0.2);
  transform: translateY(-1px);
}

.dropdown-item.view-all .item-title {
  color: #2563eb;
  font-weight: 600;
}

.dropdown-item.view-all .item-desc {
  color: #3b82f6;
}

/* 移动端菜单按钮 */
.navbar-toggle {
  display: none;
  flex-direction: column;
  justify-content: center;
  width: 34px;
  height: 34px;
  cursor: pointer;
  padding: 0.75rem;
  background: none;
  border: none;
  border-radius: 12px;
  transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  position: relative;
  overflow: hidden;
}

.navbar-toggle::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(37, 99, 235, 0.1);
  opacity: 0;
  transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  border-radius: 12px;
}

.navbar-toggle:hover::before {
  opacity: 1;
}

.toggle-line {
  width: 26px;
  height: 2.5px;
  background: #4a5568;
  margin: 3.5px 0;
  transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  border-radius: 2px;
  position: relative;
  z-index: 1;
}

.navbar-toggle.active .toggle-line:nth-child(1) {
  transform: rotate(45deg) translate(7px, 7px);
}

.navbar-toggle.active .toggle-line:nth-child(2) {
  opacity: 0;
  transform: scale(0);
}

.navbar-toggle.active .toggle-line:nth-child(3) {
  transform: rotate(-45deg) translate(7px, -7px);
}

/* 移动端菜单样式 */
.mobile-menu {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(20px);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  padding: 1.5rem;
  overflow-y: auto;
  transform: translateX(-100%);
  transition: all 0.3s ease;
}

.mobile-menu.active {
  transform: translateX(0);
}

.mobile-menu-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid rgba(229, 231, 235, 0.5);
}

.mobile-close {
  background: none;
  border: none;
  color: #374151;
  font-size: 1.25rem;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.mobile-close:hover {
  background: rgba(229, 231, 235, 0.3);
  color: #2563eb;
}

.mobile-menu-item {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  
  &:last-child {
    border-bottom: none;
  }
  
  a {
    display: block;
    color: rgba(255, 255, 255, 0.9);
    text-decoration: none;
    padding: 20px 25px;
    font-size: 16px;
    font-weight: 500;
    transition: all 0.3s ease;
    
    &:hover {
      color: #2563eb;
      background: rgba(37, 99, 235, 0.1);
      padding-left: 35px;
    }
  }
  
  &.has-dropdown {
    .mobile-menu-toggle {
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: rgba(255, 255, 255, 0.9);
      padding: 20px 25px;
      font-size: 16px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.3s ease;
      background: none;
      border: none;
      
      &:hover {
        color: #2563eb;
        background: rgba(37, 99, 235, 0.1);
      }
      
      i {
        color: #2563eb;
        font-size: 12px;
        transition: transform 0.3s ease;
        
        &.rotated {
          transform: rotate(180deg);
        }
      }
    }
    
    .mobile-dropdown {
      max-height: 0;
      overflow: hidden;
      background: rgba(0, 0, 0, 0.3);
      transition: max-height 0.3s ease;
      
      &.active {
        max-height: 500px;
      }
    }
  }
}

.mobile-dropdown-section {
  padding: 15px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  position: relative;
  
  &:last-child {
    border-bottom: none;
  }
  
  &.has-submenu {
    .mobile-submenu-toggle {
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;
      padding: 5px 25px;
      transition: all 0.3s ease;
      
      &:hover {
        color: #2563eb;
      }
      
      h4 {
        color: #2563eb;
        font-size: 14px;
        font-weight: 600;
        margin: 0;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        
        i {
          font-size: 10px;
          transition: transform 0.3s ease;
        }
      }
      
      i {
        color: #2563eb;
        font-size: 12px;
        transition: transform 0.3s ease;
        
        &.rotated {
          transform: rotate(180deg);
        }
      }
    }
    
    .mobile-submenu {
      max-height: 0;
      overflow: hidden;
      transition: max-height 0.3s ease;
      margin-left: 15px;
      border-left: 2px solid rgba(37, 99, 235, 0.3);
      padding-left: 15px;
      
      &.active {
        max-height: 200px;
      }
      
      &.submenu {
        position: absolute;
        top: 0;
        left: 100%;
        min-width: 250px;
        background: rgba(15, 23, 42, 0.98);
        backdrop-filter: blur(20px);
        border-radius: 12px;
        padding: 20px;
        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
        border: 1px solid rgba(37, 99, 235, 0.2);
        opacity: 0;
        visibility: hidden;
        transform: translateX(-10px);
        transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        z-index: 1000;
        margin-left: 0;
        border-left: none;
        padding-left: 0;
        
        &.active {
          opacity: 1;
          visibility: visible;
          transform: translateX(0);
          max-height: none;
        }
      }
      
      a {
        display: block;
        color: rgba(255, 255, 255, 0.7);
        text-decoration: none;
        padding: 8px 0;
        font-size: 13px;
        transition: all 0.3s ease;
        border-left: 2px solid transparent;
        padding-left: 10px;
        
        &:hover {
          color: #2563eb;
          border-left-color: #2563eb;
          padding-left: 15px;
        }
      }
      
      &.submenu a {
        padding: 12px 16px;
        border-radius: 8px;
        font-size: 14px;
        margin-bottom: 4px;
        
        &:hover {
          background: rgba(37, 99, 235, 0.1);
          transform: translateX(5px);
          padding-left: 16px;
        }
      }
    }
  }
  
  h4 {
    color: #2563eb;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 10px;
    padding: 0 25px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  
  a {
    display: block;
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    padding: 8px 25px;
    font-size: 14px;
    transition: all 0.3s ease;
    border-left: 2px solid transparent;
    padding-left: 40px;
    
    &:hover {
      color: #2563eb;
      border-left-color: #2563eb;
      padding-left: 45px;
    }
  }
  
  .no-click {
    display: block;
    color: rgba(255, 255, 255, 0.8);
    padding: 8px 25px;
    font-size: 14px;
    cursor: default;
  }
}

/* 移动端分割线 */
.mobile-divider {
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  margin: 10px 25px;
  border: none;
}

/* 移动端查看全部样式 */
.view-all-mobile {
  background: linear-gradient(135deg, rgba(37, 99, 235, 0.1), rgba(59, 130, 246, 0.15)) !important;
  border-radius: 8px !important;
  margin: 5px 25px !important;
  padding: 12px 20px !important;
  color: #2563eb !important;
  font-weight: 600 !important;
  text-align: center;
  border: 1px solid rgba(37, 99, 235, 0.2);
}

.view-all-mobile:hover {
  background: linear-gradient(135deg, rgba(37, 99, 235, 0.15), rgba(59, 130, 246, 0.2)) !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.2);
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .dropdown-menu {
    min-width: 750px;
  }
}

@media (max-width: 1024px) {
  .nav-menu {
    display: none;
  }

  .mobile-menu-toggle {
    display: flex;
  }

  .dropdown-menu {
    min-width: 90vw;
    left: 5vw;
    transform: none;
    border-radius: 20px;
    padding: 1.5rem;
  }

  .dropdown-menu.show {
    transform: translateY(0) scale(1);
  }

  .dropdown-content {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
  
  /* 产品菜单平板适配 */
  .products-menu {
    min-width: 90vw;
    padding: 2rem;
  }
  
  .products-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5rem;
  }
}

@media (max-width: 768px) {
  .unified-navbar {
    height: 60px;
  }
  
  .navbar-container {
    padding: 0 1rem;
    height: 60px;
  }
  
  .navbar-menu {
    display: none;
  }
  
  .navbar-actions {
    display: none;
  }
  
  .navbar-toggle {
    display: flex;
  }
  
  .products-menu {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.98);
    backdrop-filter: blur(20px);
    padding: 1.5rem;
    overflow-y: auto;
    z-index: 9999;
  }
  
  .products-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
  
  .product-category {
    background: rgba(249, 250, 251, 0.8);
    border: 1px solid rgba(229, 231, 235, 0.5);
    padding: 1.25rem;
  }
  
  .category-header {
    margin-bottom: 1rem;
    padding-bottom: 0.75rem;
  }
  
  .category-icon {
    font-size: 2rem;
    margin-bottom: 0.5rem;
  }
  
  .category-header h3 {
    font-size: 1rem;
  }
  
  .category-header p {
    font-size: 0.8rem;
  }
  
  .product-item {
    padding: 0.75rem;
  }
  
  .product-icon {
    font-size: 1.25rem;
    margin-right: 0.5rem;
  }
  
  .product-title {
    font-size: 0.85rem;
  }
  
  .product-desc {
    font-size: 0.75rem;
  }
  
  .brand-text {
    font-size: 1.3rem;
    font-weight: 800;
  }
}

@media (max-width: 480px) {
  .navbar-container {
    height: 65px;
    padding: 0 1rem;
  }
  
  .navbar-menu {
    top: 60px;
    padding: 1rem;
  }
  
  .brand-logo {
    width: 32px;
    height: 32px;
  }
  
  .brand-text {
    font-size: 1.2rem;
  }

  .mobile-nav-link {
    font-size: 1.3rem;
    padding: 0.9rem 1.8rem;
    margin: 1rem 0;
  }

  .dropdown-menu {
    padding: 1rem;
    margin: 0 10px;
  }
}
</style>
